import { StrapiID } from './common'

export type StrapiItem<T> = {
  id: StrapiID
  documentId: StrapiID
} & T

export type StrapiTranslations = {
  namespace: string
  locale: string
  updatedAt: string
  translations: Record<string, string>
  versioned?: boolean | null
}

export type StrapiPaginatedResponse<T> = {
  data: StrapiItem<T>[]
  meta: {
    pagination: {
      page: number
      pageSize: number
      pageCount: number
      total: number
    }
  }
}

export type StrapiAsset = {
  alternativeText: string | null
  ext: string
  url: string
  width: number
  height: number
  size: number
  hash: string
  mime: string
}

export type StrapiImage = StrapiItem<StrapiAsset>
